import cx from "classnames";
import "./SummaryBox.css";

const SummaryBox = (props) => {
    const {
        title, children,
        className, contentClassName,
        isFormBox, isButton, disabled,
        showBorder,
        onClick,
    } = props;

    const Element = isButton ? "button" : "div";

    return (
        <Element
            className={cx(
                "summary-box",
                { "summary-box--form": isFormBox },
                { "summary-box--button": isButton },
                { "summary-box--bordered": showBorder },
                className,
            )}
            disabled={disabled}
            onClick={onClick}
        >
            {title && (<div className="summary-box__title">{title}</div>)}
            <div className={cx("summary-box__content", contentClassName)}>
                {children}
            </div>
        </Element>
    );
};

export default SummaryBox;
